import React, {useState} from "react";
import IconButton from '@mui/material/IconButton';
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import TrafficlightButtonOrange from "../../../../../../../components/Button/TrafficlightButtonOrange";
import { TextSignalDia } from "./TextSignalDia";


export default function Dia_Signal() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
    
<IconButton onClick={handleOpen}>
    <TrafficlightButtonOrange  />
</IconButton>

<CustomDialog open={open} onClose={handleClose}

    title='Diabetes - More Variants - Analysis'

    content={ <TextSignalDia />}

/>

</>
)}